import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import styled from 'styled-components';

export const HighlightPanel = styled.div<{ margin?: string }>`
  ${flex({ flexDirection: 'column' })};
  border: 1px solid ${COLORS.grey[400]};
  background-color: ${COLORS.grey[150]};
  border-radius: 8px;
  padding: 20px 16px;

  ${({ margin }) =>
    margin &&
    `
      margin: ${margin};
  `}
`;
